import clsx from 'clsx';

export function FlagEsIcon({ className, ...props }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={clsx(className)}
      {...props}
    >
      <path d="M20 0H0V20H20V0Z" fill="#FFDA44" />
      <path d="M20 0H0V6.66652H20V0Z" fill="#D80027" />
      <path d="M20 13.3335H0V20H20V13.3335Z" fill="#D80027" />
    </svg>
  );
}
